export default function( elements ) {
	return [ elements[ elements.length - 1 ] ];
}
